import cn from 'classnames';

import * as styles from './styles.css';
import { ETestId } from '../../../../../constants';
import { EIcon } from '../../../../../repositories/dailyrent/entities/offer/Offer';
import { DISCOUNT_ICON, FAVORITE_ICON, OLD_ONLINE_BOOKING_ICON } from '../../constants';

export interface IMapIconProps {
  isViewed?: boolean;
  isActive?: boolean;
}

type TIconType = 'favorite' | 'oldOnlineBooking' | EIcon;

export function getIconRenderer(iconType: TIconType, { isViewed, isActive }: IMapIconProps): string {
  switch (iconType) {
    case 'favorite':
      return `<div class="${styles['favorite']}">${FAVORITE_ICON}</div>`;

    case EIcon.Discount:
      return `<div data-testid="pin-discount" class="${cn(
        styles['discount'],
        isActive && styles['active'],
        isViewed && styles['viewed'],
      )}">${DISCOUNT_ICON}</div>`;

    case 'oldOnlineBooking':
      return `<div data-testid="${ETestId.OnlineBookingHighlightIcon}" class="${cn(
        styles['online-booking'],
        isActive && styles['active'],
        isViewed && styles['viewed'],
      )}">${OLD_ONLINE_BOOKING_ICON}</div>`;

    default:
      return '';
  }
}
